import { ResourceUserRoleCategory } from 'src/api';
import { UserPermissions } from 'src/constants/user';
import { useCurrentUserPermissions } from 'src/hooks/user';

export const useResourcesUserRoleCategory = () => {
  const { loading, ...userPermissions } = useCurrentUserPermissions();

  const userRoleCategory = getUserRoleCategory(userPermissions);

  return {
    userRoleCategory,
    loading,
  };
};

function getUserRoleCategory(userPermissions: UserPermissions): ResourceUserRoleCategory | null {
  const { isEmployee, hasEmployerRoles, hasVerifierRoles, hasPeoRoles, isPeoPayrollProviderUser } =
    userPermissions;
  if (isEmployee) return ResourceUserRoleCategory.Employee;
  if (hasEmployerRoles) return ResourceUserRoleCategory.Employer;
  if (hasVerifierRoles) return ResourceUserRoleCategory.Verifier;
  if (hasPeoRoles) return ResourceUserRoleCategory.Peo;
  if (isPeoPayrollProviderUser) return ResourceUserRoleCategory.PeoPayrollProvider;
  return null;
}
